import React from 'react';
import { Flex, Heading, Text } from '@costar/theme-ui';

var TooltipContent = function TooltipContent(props) {
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    fontSize: "xs",
    p: "md"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    fontSize: "md",
    pb: "md",
    fontWeight: "normal",
    textAlign: "center"
  }, props.resources.title()), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "body"
  }, props.resources.intro()), /*#__PURE__*/React.createElement(Text, {
    as: "ul",
    resetCss: {
      listStyle: 'disc'
    },
    ml: "lg",
    my: "md"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "li",
    resetCss: {
      listStyle: undefined,
      wordWrap: 'break-word'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    fontWeight: "body"
  }, props.resources.option1.title()), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    fontWeight: "light"
  }, props.resources.option1.description())), /*#__PURE__*/React.createElement(Text, {
    as: "li",
    resetCss: {
      listStyle: undefined
    },
    emMarginTop: "md"
  }, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    fontWeight: "body"
  }, props.resources.option2.title()), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    fontWeight: "light"
  }, props.resources.option2.description())), /*#__PURE__*/React.createElement(Text, {
    as: "li",
    resetCss: {
      listStyle: undefined
    },
    emMarginTop: "md"
  }, /*#__PURE__*/React.createElement(Text, {
    display: "block",
    fontWeight: "body"
  }, props.resources.option3.title()), /*#__PURE__*/React.createElement(Text, {
    display: "block",
    fontWeight: "light"
  }, props.resources.option3.description()))), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "body",
    mb: "md"
  }, props.resources.footer()));
};
TooltipContent.displayName = 'TooltipContent';

export { TooltipContent };
//# sourceMappingURL=tooltip-content.esm.js.map
